import "./App.css";
import { useContext, useEffect, useState } from "react";
import About from "./pages/about/About";
import Work from "./pages/work/Work";
import Project from "./pages/project/Project";
import Contact from "./pages/contact/Contact";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Blog from "./pages/blog/Blog";
import Home from "./pages/home/Home";
import Social from "./components/social/Social";
import { ThemeContext } from "./ThemeProvider";
import Loader from "./components/loader/Loader";
import LoaderDark from "./components/loader/LoaderDark";

function App() {
  const { dark } = useContext(ThemeContext);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const anim = setTimeout(() => {
      setLoading(false);
    }, 2500);

    return () => clearTimeout(anim);
  }, []);

  useEffect(() => {
    localStorage.setItem("mode", JSON.stringify(dark));
  }, [dark]);

  return (
    <>
      {loading ? (
        dark ? (
          <LoaderDark />
        ) : (
          <Loader />
        )
      ) : (
        <div className={dark ? "app dark-mode" : "app"}>
          <Header />
          <Home />
          <About />
          <Work />
          <Project />
          <Blog />
          <Contact />
          <Social />
          <Footer />
        </div>
      )}
    </>
  );
}

export default App;
